import React, { useState }  from "react"
import { Button, Modal, Image } from "react-bootstrap"
import MetaMaskOnboarding from '@metamask/onboarding'
import MMLogo from "../../images/mm_logo.png"
import CoinbaseLogo from "../../images/coinbase_logo.png"

const styles = require("./connect-button.module.scss")

type MetaMaskConnectButtonProps = {
  getAndSetAccount: Function,
}
  
// TODO: should trigger a state change so that address repopulates and all necessary info.
// Similar issues on MintButton and we should probably bubble up state to page level to make it easy.
const MetaMaskConnectButton: React.FC<MetaMaskConnectButtonProps> = ({ getAndSetAccount }) => {
    const [shouldShowError, setShouldShowError] = useState<boolean>(false);
    const [shouldShowOptionsModal, setShouldShowOptionsModal] = useState<boolean>(false);

    // Check the ethereum binding on the window object to see if it's installed
    const { ethereum } = (typeof window !== 'undefined') ? window : { ethereum: null };

    const isMetaMaskInstalled = ethereum && !!ethereum.isMetaMask;
    const isCoinbaseInstalled = ethereum && (!!ethereum.isCoinbaseWallet || (ethereum.providers && ethereum.providers.filter(provider => provider.isCoinbaseWallet)));
    const buttonText = isMetaMaskInstalled || isCoinbaseInstalled ? "Connect Wallet" : "Install MetaMask";

    const onClickMetaMaskConnect = async () => {
      try {
        if (ethereum.providers && ethereum.providers.length > 0) {
          ethereum.providers = ethereum.providers.filter(provider => provider.isMetaMask);
        }
        // This will open the MetaMask UI
        await ethereum.request({ method: 'eth_requestAccounts' });
        getAndSetAccount();
      } catch (error) {
        setShouldShowError(true);
        setShouldShowOptionsModal(false);
      }
    };

    const onClickCoinbaseConnect = async () => {
      try {
        if (ethereum.providers && ethereum.providers.length > 0) {
          ethereum.providers = ethereum.providers.filter(provider => provider.isCoinbaseWallet);
        }
        // This will open the Coinbase UI
        await ethereum.request({ method: 'eth_requestAccounts' });
        getAndSetAccount();
      } catch (error) {
        setShouldShowError(true);
        setShouldShowOptionsModal(false);
      }
    };

    const onClickConnect = async () => {
      setShouldShowOptionsModal(true)
    };

    const onClickMetaMaskInstall = () => {
      const forwarderOrigin = 'http://localhost:8000';
      const onboarding = new MetaMaskOnboarding({ forwarderOrigin });
      onboarding.startOnboarding();
    };

    const onClickCoinbaseInstall = () => {
      window.open("https://chrome.google.com/webstore/detail/coinbase-wallet-extension/hnfanknocfeofbddgcijnmhnfnkdnaad", "_blank");
    };

    return (
      <>
        <Modal
          show={shouldShowError}
          onHide={() => setShouldShowError(false)}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Error Connecting Wallet</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            An error occurred while connecting your wallet. Please try again and post in the Discord if this issue persists.
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShouldShowError(false)}
              className="noob-dismiss-button"
            >
              Dismiss
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={shouldShowOptionsModal}
          onHide={() => setShouldShowOptionsModal(false)}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Connect Wallet</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Connect your Ethereum wallet to gain full access to the NOOBVERSE.</p>
            <Button className={styles.walletsCointainer} onClick={isMetaMaskInstalled ? onClickMetaMaskConnect : onClickMetaMaskInstall}>
              <div className={styles.wallet}>
                <Image src={MMLogo} className={styles.walletLogo} />
                <span className={styles.walletText}>MetaMask</span>
              </div>
            </Button>
            <Button className={styles.walletsCointainer} onClick={isCoinbaseInstalled ? onClickCoinbaseConnect : onClickCoinbaseInstall}>
              <div className={styles.wallet}>
                <Image src={CoinbaseLogo} className={styles.walletLogo} />
                <span className={styles.walletText}>Coinbase Wallet</span>
              </div>
            </Button>
          </Modal.Body>
        </Modal>

        <Button
          variant="outline-primary"
          onClick={onClickConnect}
          className="noob-mint-button noob-connect-to-metamask-button"
          style={{width: "100%"}}
        >
          {buttonText}
        </Button>
      </>
    )
}

export default MetaMaskConnectButton
